import React, { useState } from 'react';
import { Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { useQuery } from '@apollo/client';
import { useAccountContext } from 'contexts/account';
import { LoadingModule } from 'components/loading';
import { ErrorModule } from 'components/errors';
import { CarouselButtons } from 'components/carousel-buttons';
import {
  GET_PAYMENT_SETTINGS_INFO,
  PLAN_METHODS_PAGINATION_LIMIT,
  GET_PLANS_FOR_ADD_MODAL,
} from '../../payment-methods.api';
import { StyledCrate } from '../../payment-methods.style';
import { AddPaymentMethodModal } from '../add-payment-method-modal';
import { PlanMethodsRow } from './plan-methods-row/plan-methods-row.component';

const getCopy = copyFor('settings.paymentInformation.planMethods');

export const PlanMethods = () => {
  const { selectedAccountId } = useAccountContext();
  const [page, setPage] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);
  const { data, loading, error } = useQuery<
    GetPaymentSettingsInfoQuery,
    GetPaymentSettingsInfoQueryVariables
  >(GET_PAYMENT_SETTINGS_INFO, {
    variables: {
      accountId: selectedAccountId,
      page: page + 1,
    },
  });

  const addModalPlans = useQuery<
    GetPlansForAddModalQuery,
    GetPlansForAddModalQueryVariables
  >(GET_PLANS_FOR_ADD_MODAL, {
    variables: { accountId: selectedAccountId },
  });

  if (loading || addModalPlans.loading)
    return <LoadingModule variant="list" data-testid="plan-methods-loading" />;
  if (error || !data || addModalPlans.error || !addModalPlans.data)
    return <ErrorModule border={false} />;

  const { plans, count: activePlanCount } = data.search.plans;
  const { paymentMethods } = data.account;
  const showPagination = activePlanCount > PLAN_METHODS_PAGINATION_LIMIT;
  const methodCount = paymentMethods.length;
  const { plans: activePlans } = addModalPlans.data.search.plans;

  return (
    <>
      <StyledCrate>
        <Text textStyle="heading700" margin={{ top: '32px' }} tag="h2">
          {getCopy('title')}
        </Text>
        <Text color="secondary" margin={{ top: '16px' }}>
          {getCopy('subtitle')}
        </Text>
      </StyledCrate>
      <StyledCrate paddingLeftMobile="0px" paddingRightMobile="0px">
        <ul>
          {plans.map((plan, index) => (
            <PlanMethodsRow
              key={plan.id}
              plan={plan}
              index={index}
              counts={{ methodCount, activePlanCount }}
              openAddPaymentMethodModal={() => setShowAddModal(true)}
            />
          ))}
        </ul>
        {showPagination && (
          <CarouselButtons
            index={page}
            setIndex={setPage}
            itemName="page"
            length={Math.ceil(activePlanCount / PLAN_METHODS_PAGINATION_LIMIT)}
          />
        )}
      </StyledCrate>
      {showAddModal && (
        <AddPaymentMethodModal
          close={() => setShowAddModal(false)}
          existingPaymentMethodIds={paymentMethods.map(method => method.id)}
          activePlans={activePlans}
          activePlanCount={activePlanCount}
        />
      )}
    </>
  );
};
